import React from 'react';

const Careers = () => {
  const openPositions = [
    {
      title: 'Senior Fashion Designer',
      department: 'Design',
      location: 'New York, NY',
      type: 'Full-time'
    },
    {
      title: 'E-commerce Manager',
      department: 'Digital',
      location: 'New York, NY / Remote',
      type: 'Full-time'
    },
    {
      title: 'Customer Service Representative',
      department: 'Customer Service',
      location: 'Remote',
      type: 'Full-time'
    },
    {
      title: 'Social Media Coordinator',
      department: 'Marketing',
      location: 'New York, NY',
      type: 'Full-time'
    },
    {
      title: 'Supply Chain Analyst',
      department: 'Operations',
      location: 'New York, NY',
      type: 'Full-time'
    }
  ];

  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">CAREERS</h1>
      
      <div className="space-y-12">
        {/* About Working Here */}
        <div>
          <h2 className="text-xl font-medium mb-4">Join Our Team</h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            At Dïtris, we're building more than just a clothing brand — we're creating a culture. We're looking for passionate, creative individuals who share our commitment to quality, authenticity, and innovation.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Whether you're in design, operations, marketing, or customer service, you'll have the opportunity to shape the future of streetwear and work with a team that values creativity and collaboration.
          </p>
        </div>

        {/* Benefits */}
        <div>
          <h2 className="text-xl font-medium mb-4">Why Dïtris?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Competitive Compensation</h3>
              <p className="text-sm text-gray-600">
                Competitive salaries, performance bonuses, and equity opportunities for key roles.
              </p>
            </div>
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Health & Wellness</h3>
              <p className="text-sm text-gray-600">
                Comprehensive health, dental, and vision insurance. Plus mental health support and wellness programs.
              </p>
            </div>
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Work-Life Balance</h3>
              <p className="text-sm text-gray-600">
                Flexible working hours, remote work options, and generous PTO policy.
              </p>
            </div>
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Professional Growth</h3>
              <p className="text-sm text-gray-600">
                Learning and development budget, conference attendance, and mentorship opportunities.
              </p>
            </div>
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Employee Discount</h3>
              <p className="text-sm text-gray-600">
                Generous discount on all Dïtris products and early access to new releases.
              </p>
            </div>
            <div className="border border-gray-200 p-4">
              <h3 className="font-medium mb-2">Creative Environment</h3>
              <p className="text-sm text-gray-600">
                Work in our modern office in the heart of NYC's fashion district with a passionate team.
              </p>
            </div>
          </div>
        </div>

        {/* Open Positions */}
        <div>
          <h2 className="text-xl font-medium mb-6">Open Positions</h2>
          <div className="space-y-3">
            {openPositions.map((position, index) => (
              <div
                key={index}
                className="border border-gray-200 p-6 hover:border-black transition-colors"
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div>
                    <h3 className="text-lg font-medium mb-2">{position.title}</h3>
                    <div className="flex flex-wrap gap-3 text-sm text-gray-600">
                      <span>{position.department}</span>
                      <span>•</span>
                      <span>{position.location}</span>
                      <span>•</span>
                      <span>{position.type}</span>
                    </div>
                  </div>
                  <button className="border border-black px-6 py-2 text-sm font-medium hover:bg-black hover:text-white transition-colors whitespace-nowrap">
                    APPLY NOW
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Application Process */}
        <div>
          <h2 className="text-xl font-medium mb-4">Application Process</h2>
          <div className="space-y-4 text-gray-700">
            <div>
              <h3 className="font-medium mb-2">1. Submit Your Application</h3>
              <p className="text-sm">Send your resume and cover letter to careers@ditris.com with the position title in the subject line.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2">2. Initial Screening</h3>
              <p className="text-sm">Our team will review your application and reach out if your skills match our needs.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2">3. Interviews</h3>
              <p className="text-sm">You'll meet with team members to discuss the role, your experience, and how you'd fit into our culture.</p>
            </div>
            <div>
              <h3 className="font-medium mb-2">4. Offer</h3>
              <p className="text-sm">If it's a match, we'll extend an offer and welcome you to the Dïtris family!</p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="bg-gray-50 p-6 rounded">
          <h2 className="text-xl font-medium mb-3">Don't See Your Role?</h2>
          <p className="text-gray-700 mb-4">
            We're always looking for talented people. Send us your resume and tell us how you'd like to contribute to Dïtris.
          </p>
          <p className="text-sm">
            Email: <a href="mailto:careers@ditris.com" className="underline">careers@ditris.com</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Careers;